import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";

type Props = {
  bannerImg: string;
  title: string;
};

const HomeBanner = ({ bannerImg, title }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="relative mx-auto h-[498px] w-full max-w-[2000px]">
      <img src={bannerImg} alt="title-banner" className="h-full w-full object-cover" />
      <div className="absolute inset-0 mx-auto flex flex-col justify-center max-w-[1440px] md:pl-[100px] p-6">
        <p className="max-w-[832px] text-[48px] font-extrabold leading-[60px] text-white md:text-[72px] md:leading-[96px]">
          {title}
        </p>
        <div>
          <button
            className="mt-9 flex items-center rounded-md bg-primary px-6 py-3 text-base font-bold text-white"
            onClick={() => window.open("/contact-us", "_self")}
          >
            {t("home.contact_us")} <FaArrowRight className="rtl-icon-flip inline" style={{ marginInlineStart: "0.5rem" }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
